const isAuthRequestUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  return url.includes('/auth/');
};

const isAuthPagePath = (pathname) => {
  if (!pathname) {
    return false;
  }

  return pathname.includes('/login')
    || pathname.includes('/reset-password')
    || pathname.includes('/set-password');
};

export const requestHadAuthorizationHeader = (headers) => {
  if (!headers) {
    return false;
  }

  if (typeof headers.get === 'function') {
    const value = headers.get('Authorization') || headers.get('authorization');
    if (value) {
      return true;
    }
  }

  return Boolean(headers.Authorization || headers.authorization);
};

/**
 * A 401 means the session is gone when the call was authenticated.
 * Login and password endpoints, and pages that collect credentials, keep the error on the form.
 * The public marketing home can 401 without a session; a bearer token on that page still means the session expired.
 */
export const shouldRedirectOnUnauthorized = ({
  pathname,
  subdomainStoreMode = false,
  requestUrl,
  hadAuthorizationHeader = false,
}) => {
  if (isAuthRequestUrl(requestUrl) || isAuthPagePath(pathname)) {
    return false;
  }

  const isPublicMarketingHome = !subdomainStoreMode && (pathname === '/' || pathname === '');
  if (isPublicMarketingHome && !hadAuthorizationHeader) {
    return false;
  }

  return true;
};
